import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { getFunctionsBaseUrl } from '../lib/functionsBaseUrl';

export function useRentmanContactPersons(selectedCustomerId) {
  const [contactPersons, setContactPersons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();
  const prevCustomerId = useRef(null);
  const hasInitialized = useRef(false);

  useEffect(() => {
    const fetchContactPersons = async () => {
      if (!selectedCustomerId) {
        setContactPersons([]);
        return;
      }

      // Skip fetch if customer hasn't changed and we've already initialized
      if (selectedCustomerId === prevCustomerId.current && hasInitialized.current) {
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const baseUrl = getFunctionsBaseUrl();

        const idToken = await currentUser.getIdToken(true);

        const response = await fetch(`${baseUrl}/getRentmanContactPersons?contactId=${selectedCustomerId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (!data.success) {
          throw new Error(data.message || 'Failed to fetch contact persons');
        }

        setContactPersons(data.data || []);
        prevCustomerId.current = selectedCustomerId;
        hasInitialized.current = true;
      } catch (err) {
        console.error('Error fetching contact persons:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContactPersons();
  }, [selectedCustomerId, currentUser]);

  return { contactPersons, loading, error };
} 